import React, { useState, useEffect } from "react";
import "../../../../styles/app.css";

function Operative_General_LL({ setNameForm, onFormSubmit, onSelectionChange }) {
  const [formState, setFormState] = useState({

    Tumor_Category:"",
    Symptoms:"",

    Treatment_Option:"",

    SurgeryDetail:"",
    HospLenght:"",
    Work_incapacity:"",
    TumorBoard:"",

  });



  const [WorkUp, setWorkUp] = useState({
    
      "CT-scan": false,
      "IRM": false,
      "Arthro-IRM": false,
      "Angio-IRM": false,
      "Biopsie sous guidage": false,
      "Biospsie chirugicale incisionnelle": false,
      "Biospsie chirugicale excisionnelle": false,
      "AUTRE": false
    
    });
  
  
    const handleCheckboxChangeWorkUp = (event) => {
      const { name, checked } = event.target;
       
        setWorkUp(prev => ({
          ...prev,
          [name]: checked,
       
        }));
      
    };
  

  useEffect(() => {
    // Run this when the component mounts
    onSelectionChange(true);

    // Run this when the component unmounts
    return () => {
      onSelectionChange(false);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormState(prevState => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();

    setNameForm("Attitude, orthopédie oncologique");
    // Here is where you would prepare the object with the form details to send to the onFormSubmit function
    const formDetails = {
      "Madame/Monsieur présente donc une": formState.Tumor_Category


    };


    const filteredFormDetails = Object.entries(formDetails) // Convert the object to an array of key-value pairs
    .filter(([key, value]) => value !== "")               // Filter out pairs where the value is an empty string
    .reduce((obj, [key, value]) => {                      // Reduce the array back to an object
      obj[key] = value;                                   // Add each key-value pair to the object
      return obj;                                         // Return the object for the next iteration
    }, {});                                               // Start with an empty object


    onFormSubmit(filteredFormDetails); // Make sure this prop is passed correctly from App.js
  }

  return (
    <div className="card">
      <p className="title">Attitude, orthopédie oncologique</p>
      <form className="specific-form" onSubmit={handleSubmit}>

      <div>
     
        <select className="select-input" name="Tumor_Category" value={formState.Tumor_Category} onChange={handleInputChange} >
          <option value="">Catégorie tumeur</option>
          <option value="une lésion indéterminée">indéterminée</option>
          <option value="Tumeur bénigne">Tumeur bénigne</option>
          <option value="Tumeur bénigne mais localement agressive">Tumeur bénigne mais localement agressive</option>
          <option value="Tumeur maligne">Tumeur maligne</option>
      
        </select>

      
        </div>


        {formState.Tumor_Category === "Tumeur bénigne" && (
        <>
        <label>Option traitement, tumeur bénigne: </label>
        <select className="select-input" name="Treatment_Option" value={formState.Treatment_Option} onChange={handleInputChange} >
        <option value=""></option>
          <option value="Pas de prise en charge chirgicale, pas de suivi nécessaire">Pas de prise en charge chirgicale, pas de suivi nécessaire</option>
          <option value="Surveillance clinique">Surveillance clinique</option>
          <option value="Surveillance radio-clinique">Surveillance radio-clinique</option>
          <option value="Prise en charge chirurgicale, pour résection marginale">Prise en charge chirurgicale, pour résection marginale</option>
            
        </select>        


        <select className="select-input" name="Symptoms" value={formState.Symptoms} onChange={handleInputChange} >
        <option value="">Symptômes</option>
          <option value="Asymtomatique">Asymtomatique</option>
          <option value="Pas de douleurs, pas de limitation fonctionnelle">Pas de douleurs, pas de limitation fonctionnelle</option>
          <option value="Douleurs occasionnelle">Douleurs occasionnelle</option>
          <option value="Douleurs importantes">Douleurs importantes</option>
          <option value="Douleurs invalidantes">Douleurs invalidantes</option>    
        </select>


        </>
      )}

      {formState.Tumor_Category === "indéterminée, en cours de bilan" && (
        <>
        <label>Option traitement, tumeur bénigne: </label>
        <select className="select-input" name="Treatment_Option" value={formState.Treatment_Option} onChange={handleInputChange} >
        <option value=""></option>
          <option value="Pas de prise en charge chirgicale, pas de suivi nécessaire">Pas de prise en charge chirgicale, pas de suivi nécessaire</option>
          <option value="Surveillance clinique">Surveillance clinique</option>
          <option value="Surveillance radio-clinique">Surveillance radio-clinique</option>
          <option value="Prise en charge chirurgicale, pour résection marginale">Prise en charge chirurgicale, pour résection marginale</option>
            
        </select>        

        </>
      )}
        




    
        <button type="submit" className="button send">Send</button>
      </form>
    </div>
  );
}

export default Operative_General_LL;